module.exports = __webpack_public_path__ + "static/media/LK_Alarm.e986474d.svg";